// Contact details from Company Profile - masesV1.3 - Print.pdf, page 9.
export const company = {
  name: "MASES Bangunan",
  legalName: "PT. Maha Sukses Mulia",
  description:
    "Supplier bahan bangunan dan perlengkapan rumah untuk pemilik rumah, renovator, kontraktor, hingga developer.",
  address:
    "Graha Citra Blok BC6, Jl. Banjar Wijaya, Kel. Cipete, Kec. Pinang, Kota Tangerang, Banten",
  phone: "+6285185408198",
  phoneDisplay: "+62 851-8540-8198",
  email: "Sales@masesbangunan.com",
  workingDays: "Senin–Sabtu",
  workingHours: "08.00–17.00 WIB",
  whatsappUrl: process.env.REACT_APP_COMPANY_WHATSAPP_URL,
  websiteUrl: process.env.REACT_APP_COMPANY_WEBSITE_URL,
  instagramUrl: process.env.REACT_APP_COMPANY_INSTAGRAM_URL,
  mapsUrl: process.env.REACT_APP_COMPANY_MAPS_URL,
};

for (const field of ["whatsappUrl", "websiteUrl", "instagramUrl", "mapsUrl"]) {
  if (!company[field]) throw new Error(`Missing company contact configuration: ${field}`);
}